<template>
  <div class="credentials">
    <h3 class="credentials__header--text">Credentials</h3>
    <div
      v-for="item in keyItems"
      :key="item.field"
      class="credentials__key-box"
    >
      <div class="key-box">
        <h5 class="key-box__label">{{ item.label }}</h5>
        <div class="key-box-info">
          <input
            class="key-box-info__id"
            type="text"
            :value="item.value || item.placeholder"
            size="36"
            :ref="item.ref"
            readonly
            :class="{
              'key-box-info__id--disabled': !item.value
            }"
          />
          <button
            class="key-box-info__copy-btn"
            :disabled="!item.value"
            :class="{
              'key-box-info__copy-btn--disabled': !item.value
            }"
            @click="item.value && copyToClipboard(item.field)"
          >
            <svg>
              <use v-bind="{
                'xlink:href': copyStatus[item.field]
                  ? '#copied-icon' : '#copy-icon'
              }" />
            </svg>
            <div
              class="tool-tip"
              :class="copyStatus[item.field] ? 'copied' : null"
            >
              {{ copyStatus[item.field] ? 'Copied' : 'Copy Key' }}
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WidgetCredentials',
  props: {
    projectKey: { type: String, default: '' },
    apiKey: { type: String, default: '' },
    accessKey: { type: String, default: '' },
  },
  data() {
    return {
      copyStatus: {
        projectKey: false,
        apiKey: false,
        accessKey: false,
      },
    };
  },
  computed: {
    keyItems() {
      return [
        {
          field: 'projectKey',
          label: 'Project Key',
          value: this.projectKey,
          ref: 'projectKeyRef',
          placeholder: '',
        },
        {
          field: 'apiKey',
          label: 'API Key',
          value: this.apiKey,
          ref: 'apiKeyRef',
          placeholder: '',
        },
        {
          field: 'accessKey',
          label: 'Public Key',
          value: this.accessKey,
          ref: 'accessKeyRef',
          placeholder: 'Not yet generated',
        },
      ];
    },
  },
  methods: {
    copyToClipboard(field) {
      const refMap = {
        projectKey: 'projectKeyRef',
        apiKey: 'apiKeyRef',
        accessKey: 'accessKeyRef',
      };
      const els = this.$refs[refMap[field]];
      const copyText = Array.isArray(els) ? els[0] : els;
      if (copyText) {
        copyText.select();
        copyText.setSelectionRange(0, 100000);
        document.execCommand('copy');
        this.copyStatus[field] = true;
        setTimeout(() => {
          this.copyStatus[field] = false;
        }, 10000);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.credentials {
  max-width: size(400);

  &__header--text {
    @include font-styles($type: 'text', $size: 'lg', $weight: 'bold');
    padding-bottom: size(14);
    color: var(--global--main--title--Color);
  }

  &__key-box {
    background: var(--global--white--Color);
    box-shadow: 0 size(1) size(3) rgba(0, 0, 0, 0.1),
      0 size(2) size(1) rgba(0, 0, 0, 0.06),
      0 size(1) size(1) rgba(0, 0, 0, 0.08);
    border-radius: size(8);
    margin-bottom: size(14);
    padding: size(15);
  }
}

.key-box {
  padding-bottom: size(6);
  border-bottom: size(1) solid var(--global--line--table--BackgroundColor);

  &__label {
    @include font-styles($type: 'label', $size: 'lg', $weight: 'bold');
    text-align: left;
    padding-bottom: size(6);
    color: var(--global--main--title--Color);
  }
}

.key-box-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  transition: visibility 0.3s linear;

  &:hover {
    .key-box-info__copy-btn {
      visibility: visible;
    }
  }

  &__id {
    @include font-styles($type: 'label', $size: 'lg', $weight: 'regular');
    padding: 0;
    border: none;
    outline: none;
    color: var(--global--main--Color);
    width: size(330);
    padding-right: size(5);
    cursor: pointer;

    &::selection {
      background: transparent;
    }

    &--disabled {
      opacity: 0.4;
      cursor: default;
    }
  }

  &__copy-btn {
    visibility: hidden;
    position: relative;
    cursor: pointer;
    padding-left: size(5);
    background: none;
    border: none;

    &:hover,
    &:focus,
    &:active {
      outline: none;
    }

    svg {
      max-height: size(15);
      max-width: size(15);
      fill: var(--global--main-title--Color);
    }

    .tool-tip {
      @include font-styles($type: 'label', $size: 'sm', $weight: 'regular');
      position: absolute;
      bottom: size(30);
      left: size(-40);
      width: size(90);
      display: none;
      opacity: 0;
      padding: size(5) size(10);
      text-align: center;
      box-shadow: size(0) size(1) size(4) rgba(0, 0, 0, 0.15);
      color: var(--global--main--title--Color);
      border-radius: size(3);
      background: var(--global--white--Color);
      cursor: alias;

      &.copied {
        display: block;
        opacity: 1;
        color: var(--global--common-link--Color);
      }
    }

    &:hover .tool-tip {
      display: block;
      opacity: 1;
    }

    &--disabled {
      opacity: 0.3;
      cursor: default;
      pointer-events: none;
    }
  }
}
</style>
